import { Directive } from "@angular/core";

import { AIPEmailBuilderBlock } from "../../core/Block";
import { IBorder, IFont, ILineHeight, ILink, IPadding, TAlign, TIPEmailBuilderStyles } from "../../interfaces";
import { createBorder, createFont, createLineHeight, createPadding } from "../../tools/utils";

/**
 * Builder {@link CustomBlock} options interface.
 */
export interface ICustomBlockOptions {
  backgroundColor: string;
  border: IBorder;
  color: string;
  font: IFont;
  align: TAlign;
  fullWidth: boolean;
  lineHeight: ILineHeight;
  link: ILink;
  innerPadding: IPadding;
  padding: IPadding;
}

@Directive()
export class CustomBlock extends AIPEmailBuilderBlock<ICustomBlockOptions> {
  override type = "button";
  innerText = $localize`:@@_block_default_innerText:heyyy`;
  options: ICustomBlockOptions = {
    backgroundColor: "#414141",
    border: {
      color: "#414141",
      style: "solid",
      sizes: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
      },
      width: 0,
      radius: 3
    },
    color: "#ffffff",
    font: {
      fallback: "Arial, Helvetica, sans-serif",
      family: "Roboto",
      size: 13,
      style: "normal",
      weight: 400
    },

    align: "center",
    fullWidth: false,
    // verticalAlign: 'middle',
    lineHeight: {
      value: 120,
      unit: "%"
    },
    link: {
      href: "",
      target: "_blank"
    },
    innerPadding: {
      top: 10,
      right: 25,
      bottom: 10,
      left: 25
    },
    padding: {
      top: 10,
      right: 25,
      bottom: 10,
      left: 25
    }
  };

  get hostStyles(): TIPEmailBuilderStyles {
    const { align, padding } = this.options;

    return {
      textAlign: align,
      ...createPadding(padding)
    };
  }

  get buttonStyles(): TIPEmailBuilderStyles {
    const {
      backgroundColor,
      border,
      color,
      font,
      lineHeight,
      innerPadding,
      fullWidth
    } = this.options;

    return {
      color,
      width: fullWidth ? "100%" : "auto",
      backgroundColor,
      ...createFont(this.parseFont(font)),
      ...createPadding(innerPadding),
      ...createBorder(border),
      ...createLineHeight(lineHeight)
    };
  }

  override toObject(options?: Partial<ICustomBlockOptions>, innerText = this.innerText) {
    return { ...super.toObject(options), innerText };
  }
}
